<style scoped lang="scss">

</style>

<template>
  <div>
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='Link' href="/sector-targets">Sector Targets</b-breadcrumb-item>
      <b-breadcrumb-item tag='Link' active>
        {{ sectorTarget.label }}
      </b-breadcrumb-item>
    </b-breadcrumb>

    <section class="section">
      <h2 class="title">
        {{sectorTarget.label}}
      </h2>

      <div class="columns">
        <div class="column">
          <div class="panel">
            <div class="panel-heading">
              <h2 class="panel-title">Market</h2>
            </div>
            <div class="panel-block">
              <Link :href="`/markets/${sectorTarget.market.id}/edit`">{{ sectorTarget.market.city }}, {{ sectorTarget.market.state }}</Link>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="panel">
            <div class="panel-heading">
              <h2 class="panel-title">Vertical</h2>
            </div>
            <div class="panel-block">
              <Link :href="`/verticals/${sectorTarget.vertical.id}/edit`">{{ sectorTarget.vertical.name }}</Link>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="panel">
            <div class="panel-heading">
              <h2 class="panel-title">Leads</h2>
            </div>
            <div class="panel-block">
              {{ leads.total }}
            </div>
            <div class="panel-block">
              <Link :href="`/sector-targets/${sectorTarget.id}/leads/create`" class="button is-primary is-small">Create Lead</Link>
            </div>
          </div>
        </div>

      </div>

    </section>

    <card-component
      title="Businesses"
      has-button-slot>
      <div class="has-text-centered notification is-dark-passive" v-if="businesses.length === 0">
        <p>No businesses for {{ sectorTarget.label }}, you can create one below.</p>
      </div>
      <b-table :data="businesses" v-else>

        <b-table-column label="Name" v-slot="props">
          {{ props.row.name }}
        </b-table-column>

        <b-table-column label="Website" v-slot="props">
          <span v-if="props.row.domain">
            <div>
              <a :href="'https://'+props.row.domain.name" target="_blank">
              {{ props.row.domain.name }}
              <i class="fa fa-link"></i>
            </a>
            </div>
            <div>
              <b-tag type="is-warning" rounded>Performance 58</b-tag>
              <b-tag type="is-success" rounded>Accessibility 100</b-tag>
              <b-tag type="is-danger" rounded>Best Practices 20</b-tag>
              <b-tag type="is-warning" rounded>SEO 87</b-tag>
            </div>
          </span>
        </b-table-column>

        <b-table-column numeric v-slot="props">
          <b-tooltip
            type="is-dark"
            position="is-left"
            :label="props.row.id === sectorTarget.current_customer_id ? 'Current Customer for Sector Target' : 'Make Current Customer'">
            <Link class="button"
                  method="post"
                  :disabled="props.row.id === sectorTarget.current_customer_id"
                  :class="{'is-primary': props.row.id === sectorTarget.current_customer_id}" :href="`/sector-targets/${sectorTarget.id}/set-customer/${props.row.id}`">
              <i class="fa fa-usd"></i>
            </Link>
          </b-tooltip>
          <Link class="button is-primary" :href="`/sector-targets/${sectorTarget.id}/businesses/${props.row.id}/edit`">
            <i class="fa fa-edit"></i>
            </Link>

          <Link class="button is-danger" @click="deleteBusiness(props.row)">
            <i class="fa fa-trash"></i>
          </Link>
        </b-table-column>
      </b-table>


      <Link class="button is-primary is-fullwidth mt-4" :href="`/sector-targets/${sectorTarget.id}/businesses/create`">
        <i class="fal fa-plus-circle mr-2"></i>
        Add Business
      </Link>
    </card-component>

      <card-component title="Leads" has-button-slot>
        <div class="is-flex is-justify-content-space-between is-align-items-center mb-6">
          <b-button @click="copySnippet" type="is-dark-passive mx-4">
            <i class="fa fa-copy"></i>
            Copy Form Embed Code
          </b-button>
          <b-button type="is-dark-passive mx-1" :class="{ 'is-info': formIsDarkMode }" @click="toggleFormDarkMode">
            <i class="fa fa-moon"></i>
          </b-button>
          <input style="display: none" ref="iframesnippet" :value="iframeSnippetText"/>
          <pre >&lt;iframe src="http://normandy.test/lead-form?uuid={{ sectorTarget.uuid }}{{ formDarkModeParam }}" frameborder="0" scrolling="no" style="height: 100%; width: 100%;"/></pre>
        </div>


        <div v-if="leads.total" >
        <a inverted class="button mx-4" :href="`/sector-targets/${sectorTarget.id}/export-leads`">
          <i class="fa fa-file-excel mr-2"></i>
          Export
        </a>
          <b-table :data="leads.data">
            <b-table-column label="Name" v-slot="props">
              {{ props.row.contact.first_name }} {{ props.row.contact.last_name }}
            </b-table-column>

            <b-table-column label="Email" v-slot="props">
              <a :href="'mailto:'+props.row.contact.email">{{ props.row.contact.email }}</a>
            </b-table-column>

            <b-table-column label="Subject" v-slot="props">
              {{ props.row.request_title }}
            </b-table-column>

            <b-table-column label="Created" v-slot="props">
              {{ props.row.created_at | moment('MM/DD/YYYY hh:mm a') }}
            </b-table-column>

            <b-table-column numeric v-slot="props">
              <Link
                class="button is-info"
                :href="`/sector-targets/${sectorTarget.id}/leads/${props.row.id}`">
                <i class="fa fa-pencil"></i>
              </Link>
            </b-table-column>
          </b-table>
        </div>

      </card-component>




    <card-component title="Domains" has-button-slot>

      <domain-search class="mb-4" :sector-target="sectorTarget"/>

      <Link class="button is-primary is-fullwidth" :href="`/sector-targets/${sectorTarget.id}/businesses/create`">
        <i class="fal fa-plus-circle mr-2"></i>
        Add Domain
      </Link>
    </card-component>
  </div>

</template>

<script>
import {Head, Link} from '@inertiajs/vue2'
import Layout from '@/Shared/Layout'
import DomainSearch from '@/Shared/DomainSearch'
import CardComponent from "@/Shared/CardComponent";

export default {
  components: {
    CardComponent,
    Head,
    Link,
    DomainSearch,
  },
  layout: Layout,
  props: {
    businesses: Array,
    sectorTarget: Object,
    leads: Object,
  },
  data() {
    return {
      showEmbedUrl: false,
      formIsDarkMode: false,
    }
  },
  computed: {
    formDarkModeParam: function () {
      if(this.formIsDarkMode){
        return '&dark-mode=true'
      }
      return ''
    },
    iframeSnippetText: function(){
      return '<iframe src="http://normandy.test/lead-form?uuid='+this.sectorTarget.uuid+this.formDarkModeParam+' frameborder="0" scrolling="no" style="height: 100%; width: 100%;"/>'
    }
  },
  methods: {
    copySnippet(){
      let snippet = this.$refs.iframesnippet;
      snippet.style.display = 'block'
      snippet.select();
      document.execCommand('copy');
      snippet.style.display = 'none'
    },
    toggleFormDarkMode(){
      this.formIsDarkMode = !this.formIsDarkMode;
    },
    deleteBusiness(business) {
      this.$buefy.dialog.confirm({
        title: 'Delete Business',
        message: `Are you sure you want to delete <strong>${business.name}</strong>?`,
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$inertia.delete(`/sector-targets/${this.sectorTarget.id}/businesses/${business.id}`)
        },
      });
    },
  }
}
</script>
